import React, { useState } from "react";
import CustomButton from "../../../../../../shared_components/CustomButton";
import img from "../../../../../../assets/images/AISummit/aicopilot3.jpg";
import profileImg from "../../../../../../assets/images/community/team/profile1.png";
import Form from "../../../../FreeCodeClass/components/FreeCodeClassPage/SharedComponents/Form";

const InstructorSection = ({ upcomingSessionDetails }) => {
    const [toggleFreeCodeClassFormModal, setToggleFreeCodeClassFormModal] =
        useState(false);
    const [success, setSuccess] = useState(false);

    const avatars = [
        profileImg,
        profileImg,
        profileImg,
        profileImg,
    ];

    return (
        <section className="row mx-0 align-items-center justify-content-center my-5 py-5">
            <div className="col-12 col-md-10">
                <div className="row mx-0 align-items-center">
                    <div className="col-12 col-md-6">
                        <span className="bg-transparent border p-2 radius-10 text-dark">
                            🎉 Free Weekend Sessions
                        </span>

                        <h1 className="fw-bold mt-3">
                            Hey! I'm <span className="text-primary">Akshay</span>
                        </h1>

                        <p className="mb-3">
                            Your friendly neighborhood frontend expert with 10 years of
                            battle scars and victories.
                        </p>

                        <p className="mb-4">
                            Every weekend, I host <strong>completely free</strong> revision
                            sessions where we dive deep into frontend fundamentals, share
                            industry secrets, and learn what actually works in real projects.
                            No fluff, no sales pitch — just pure knowledge sharing.
                        </p>

                        <div className="d-flex gap-2 my-4">
                            <CustomButton
                                className="py-lg-3 py-md-0 py-3 btn rounded-pill font-weight-bold"
                                buttonName="Reserve Your Spot"
                                buttontype="button"
                                onClick={() => {
                                    setSuccess(false);
                                    setToggleFreeCodeClassFormModal(true);
                                }}
                            />

                            <CustomButton className="bg-transparent border text-dark rounded-pill">
                                Learn More
                            </CustomButton>
                        </div>
                        <div className="row mx-0 align-items-center">
                            <div className="col-auto d-flex align-items-center">
                                <div className="d-flex avatar-stack">
                                    {avatars.map((image, index) => (
                                        <img
                                            key={index}
                                            src={image}
                                            alt="profile-img"
                                            className="avatar"
                                        />
                                    ))}
                                </div>

                                <p className="mb-0 ml-3 text-muted">
                                    Joined by <strong>500+</strong> developers
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 text-center mt-4 mt-md-0">
                        <img
                            src={img}
                            alt="Akshay"
                            className="img-fluid rounded-4"
                        />
                    </div>

                </div>
            </div>

            <Form
                model={toggleFreeCodeClassFormModal}
                toggle={() => {
                    setToggleFreeCodeClassFormModal(false);
                    setSuccess(false);
                }}
                modelTitle="RevisionClass Form"
                modelDescription="Fill out the form to join the RevisionClass."
                success={success}
                sessionTitle={{ heading: "revision-class", time: "6pm" }}
                onSuccess={setSuccess}
            />
        </section>
    );
};

export default InstructorSection;
